import api from '@/client/core/api'
import { PutTagBody } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * PUT /twitter_benchmark_campaign_posts/tags/:tagId
 */
export async function putTwBenchmarkTagById(
  tagId: number,
  groupId: number,
  body: PutTagBody
): Promise<TwBenchmarkApiResult<boolean>> {
  const response = await api.put<TwBenchmarkApiResponse<boolean>>(
    `/twitter_benchmark_campaign_posts/tags/${tagId}`,
    body,
    { params: { groupId } }
  )

  return handleApiResponse<boolean>(response)
}
